import { usePasteConfig, type InputTableColumn } from '@/components/custom/erp';

interface UseBankFeePasteProps {
  columns: InputTableColumn[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<unknown[]>; resultField?: string }>
  ) => void;
}

export const useBankFeePaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseBankFeePasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
